import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconCalendar: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg
        aria-hidden="true"
        className={`icon-component ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect className="stroke" x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line className="stroke" x1="16" y1="2" x2="16" y2="6" />
        <line className="stroke" x1="8" y1="2" x2="8" y2="6" />
        <line className="stroke" x1="3" y1="10" x2="21" y2="10" />
    </svg>
)
